import useResponsiveScreen from '../../../hooks/useResponsiveScreen';

export const useSliderAdjustmentsDimension = () => {
  const { isMobile } = useResponsiveScreen();

  const SLIDER_WIDTH = 185;
  const SLIDER_DOT_WIDTH = isMobile ? 23 : 14;
  const SLIDER_MAX_VALUE = SLIDER_WIDTH - SLIDER_DOT_WIDTH;
  const SLIDER_ADJUSTMENTS_MIN_VALUE = -100;
  const SLIDER_ADJUSTMENTS_MAX_VALUE = 100;
  const SLIDER_CONTAINER_HEIGHT = SLIDER_DOT_WIDTH + 22;

  return {
    SLIDER_WIDTH,
    SLIDER_DOT_WIDTH,
    SLIDER_MAX_VALUE,
    SLIDER_ADJUSTMENTS_MIN_VALUE,
    SLIDER_ADJUSTMENTS_MAX_VALUE,
    SLIDER_CONTAINER_HEIGHT,
  };
};
